export const ACTIONS = {
  RECORD_CLIENT_EVENT: 'RECORD_CLIENT_EVENT',
  CLEAR_CLIENT_EVENTS: 'CLEAR_CLIENT_EVENTS',
  RECORD_BATCHED_CLIENT_EVENT: 'RECORD_BATCHED_CLIENT_EVENT',
};

export const publishClientEvent = data => ({
  type: ACTIONS.RECORD_CLIENT_EVENT,
  payload: data,
});

export const clearClientEvents = ids => ({
  type: ACTIONS.CLEAR_CLIENT_EVENTS,
  payload: {
    eventIds: ids,
  },
});

export const publishClientEventFromHook = data => ({
  type: ACTIONS.RECORD_CLIENT_EVENT,
  payload: data,
});

export const publishBatchedClientEventFromHook = data => ({
  type: ACTIONS.RECORD_BATCHED_CLIENT_EVENT,
  payload: data,
});
